var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 231,
    viewBox: "0 0 139 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 115L69.5 229.5L137 115L69.5 75L2 115Z",
    fill: "#F9BD36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 115L69.5 229.5L137 115M2 115L69.5 75L137 115M2 115L69.5 157.5L137 115",
    stroke: "black",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 148.5L12.5 114L69.5 80L126.5 114L69 148.5Z",
    stroke: "black",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 229V157",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 98.5L69.5 2L137 98.5L69.5 138.5L2 98.5Z",
    fill: "#F9BD36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 98.5L69.5 2L137 98.5M2 98.5L69.5 138.5L137 98.5M2 98.5L69.5 60.5L137 98.5",
    stroke: "black",
    strokeWidth: 1.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 2V138.5",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.5ce601d289a2d9c9315de85a1c39ec01.svg";
export { ForwardRef as ReactComponent };